// extracted by mini-css-extract-plugin
export default {"container":"LayoutContainer_container__EfrHf"};